<div class="icon-container">
  <mat-icon svgIcon="add-photo-alternate"></mat-icon>
</div>
